export default "__VITE_ASSET__BsR5DV_H__"